import React, { useContext } from "react";
import { CartContext } from "../CartContext";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { cart, removeFromCart } = useContext(CartContext);
  const navigate = useNavigate();
  const total = cart.reduce((s, i) => s + i.price, 0);

  return (
    <div className="cart-page">
      <h2 className="cart-title">Your Cart</h2>

      <div className="cart-list">
        {cart.length === 0 ? (
          <p className="cart-empty">Your cart is empty.</p>
        ) : (
          cart.map(item => (
            <div key={item._id} className="cart-item-box">
              <div className="cart-info">
                <h3>{item.name}</h3>
                <p className="cart-price">₹{item.price}</p>
              </div>

              <button
                className="cart-remove-btn"
                onClick={() => removeFromCart(item._id)}
              >
                Remove
              </button>
            </div>
          ))
        )}
      </div>

      {cart.length > 0 && (
        <>
          <p className="cart-total">Total: ₹{total}</p>

          <button
            className="cart-checkout-btn"
            onClick={() =>
              navigate("/checkout", { state: { items: cart } })
            }
          >
            Proceed to Checkout
          </button>
        </>
      )}
    </div>
  );
};

export default Cart;
